"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModuleByNameSelector = exports.useModulesSelector = void 0;
exports.moduleByNameSelector = moduleByNameSelector;
const effector_react_1 = require("effector-react");
const ramda_1 = require("ramda");
const store_1 = require("./store");
const useModulesSelector = () => (0, effector_react_1.useStore)(store_1.$moduleRegistry);
exports.useModulesSelector = useModulesSelector;
function moduleByNameSelector(state, moduleName) {
    return (0, ramda_1.path)([moduleName], state);
}
const useModuleByNameSelector = (moduleName) => (0, effector_react_1.useStoreMap)(store_1.$moduleRegistry, (state) => moduleByNameSelector(state, moduleName));
exports.useModuleByNameSelector = useModuleByNameSelector;
